<template>
  <div class="message-actions">
    <span>Resend:</span>
    <div>
      <button
        class="message-actions__item bg-primary"
        v-for="item in items"
        :key="item.id"
        @click="resend(item.id)"
        :disabled="
          loadingItems.indexOf(item.id) >= 0 ||
          disabledItems.indexOf(item.id) >= 0
        "
      >
        {{ item.label }}
      </button>
    </div>
  </div>
</template>

<script>
import API from '../../../../api'
export default {
  name: 'message-actions',
  props: {
    items: Array,
    message: Object
  },
  data() {
    return {
      disabledItems: [],
      loadingItems: []
    }
  },
  computed: {
    endpointId() {
      return this.$store.getters.endpointId
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    }
  },
  watch: {
    message() {
      this.disabledItems = []
      this.loadingItems = []
    }
  },
  methods: {
    async resend(pluginId) {
      this.loadingItems.push(pluginId)
      try {
        await API.messages.resend({
          projectId: this.currentProject.id,
          endpointId: this.endpointId,
          uuid: this.message.uuid,
          pluginId
        })
      } catch (err) {
        this.disabledItems.push(pluginId)
      } finally {
        const index = this.loadingItems.indexOf(pluginId)
        this.loadingItems.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="scss">
.message-actions {
  position: relative;
  display: flex;
  align-items: center;
  span {
    margin-right: 1rem;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
  }
  div {
    display: flex;
    align-items: center;
  }
  &__item {
    display: block;
    padding: 4px 6px 2px;
    color: #fff;
    font-size: 10px;
    text-transform: uppercase;
    border: 0;
    transition: 0.2s;
    &:first-child {
      border-top-left-radius: $border-radius-sm;
      border-bottom-left-radius: $border-radius-sm;
    }
    &:last-child {
      border-top-right-radius: $border-radius-sm;
      border-bottom-right-radius: $border-radius-sm;
    }
    &[disabled] {
      opacity: 0.6;
      pointer-events: none;
    }
  }
}
</style>
